import React from 'react'
import Text from 'react-text'
import {Consumer} from '../../../context'
import {viewerGuard, subdomainResource} from 'helpers/url'

export default function  ResourceRow ({kind, id}) {
  return (
    <Consumer>{ (context) => {
      const {translate, translations, profile} = context
      const {project} = profile.institution
      

      const name = part => ['viewer','viewer-student'].indexOf(id) >= 0
        ? `${kind}_${project}_${id}_${part}`
        : `${kind}_${id}_${part}`
      const downloadLink = translate(name('download'))
      const href = /^http[s]*:\/\//.test(downloadLink)
        ? downloadLink
        : `//${subdomainResource('www', downloadLink)}`
      return (
        <tr className={kind}>
          <td className= "name"><Text id={name('name')} /></td>
          <td className= "description"><Text id={name('description')} /></td>
          <td className= "download"><a {...viewerGuard({target: "_blank", href})}><Text link /></a></td>
        </tr>
      )
    }}</Consumer>
  );
}
